import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {
  Page,
  ProcessPointRound,
  ProcessStatus,
  SrmPointJob,
  SrmPointJobDto
} from "../../../../../generated-model/model";
import {SrnProcessPointResource} from "../../../../service/SrnProcessPointResource";
import {DecimalPipe} from "@angular/common";
import {IgnoreNullHttpParams} from "../../../../shared/commons/Ignore-null-http-params";
import {PointJobStatusComponent} from "../../../../shared/components/point-status/point-job-status.component";
import {
  PointChecklistModalService
} from "../../../../shared/components/point-checklist-modal/point-checklist-modal.service";
import {AlertDialogService} from "../../../../shared/commons/dialog/alert-dialog/alert-dialog.service";
import {S3Resource} from "../../../../service/s3-resource.service";

@Component({
  selector: 'app-point-history',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NotFoundComponent,
    SharedCommonModule,
    DecimalPipe,
    PointJobStatusComponent
  ],
  templateUrl: './point-history.component.html',
  styleUrl: './point-history.component.scss'
})
export class PointHistoryComponent implements OnInit {
  pageData: Page<SrmPointJobDto> = {number: 0, size: 10};
  params = signal<any>({});
  ProcessStatus = ProcessStatus;
  currentRound = signal<ProcessPointRound>(undefined);
  private readonly service = inject(SrnProcessPointResource);
  private readonly checkListModalService = inject(PointChecklistModalService);
  private readonly alertDialogService = inject(AlertDialogService);
  private readonly s3Resource = inject(S3Resource);

  ngOnInit(): void {
    this.service.getCurrentRound()
      .subscribe(value => {
        this.currentRound.set(value);
        console.log('currentRound: ', value);
      })
    this.search(1);
  }

  search(page: number = 1) {
    const param = IgnoreNullHttpParams.fromObject({
      ...this.params(),
      page: page - 1,
      size: this.pageData.size,
      sort: 'id,desc'
    })
    this.service.search(param)
      .subscribe(e => {
        this.pageData = e;
      });
  }

  isCurrentRound(item: SrmPointJob) {
    return this.currentRound().month == item?.id?.month && this.currentRound().round == item?.id?.round;
  }

  openChecklistModal(item: SrmPointJob) {
    this.checkListModalService.open(item.checklist).subscribe();
  }

  downloadFile(item: SrmPointJob) {
    if (!item.mdbFile) {
      this.alertDialogService.open({content: 'ไม่พบไฟล์'});
      return;
    }
    this.s3Resource.downloadFromFile(item.mdbFile);
  }
}
